import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';
import { ProjectNotificationsStatus } from '../../fragments/generated/ProjectNotificationsStatus';
import { ProjectNotificationsOverrideStatus } from '../../fragments/generated/ProjectNotificationsOverrideStatus';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type EnableProjectNotificationsMutationVariables = Types.Exact<{
  input: Types.ToggleProjectNotificationsInput;
}>;


export type EnableProjectNotificationsMutation = { __typename?: 'Mutation', enableProjectNotifications?: { __typename?: 'ToggleProjectNotificationsPayload', project?: { __typename?: 'Project', id: string, notificationsEnabled?: boolean | null, hasProjectNotificationsOverride?: boolean | null } | null } | null };


export const EnableProjectNotifications = /*#__PURE__*/ gql`
    mutation EnableProjectNotifications($input: ToggleProjectNotificationsInput!) {
  enableProjectNotifications(input: $input) {
    project {
      ...ProjectNotificationsStatus
      ...ProjectNotificationsOverrideStatus
    }
  }
}
    ${ProjectNotificationsStatus}
${ProjectNotificationsOverrideStatus}` as unknown as DocumentNode<EnableProjectNotificationsMutation, EnableProjectNotificationsMutationVariables>;

          

          export const useEnableProjectNotificationsMutation = (options?:MutationHookOptions<EnableProjectNotificationsMutation, EnableProjectNotificationsMutationVariables>) => useMutation(EnableProjectNotifications, options);
          

          export type EnableProjectNotificationsMutationOptions = MutationHookOptions<EnableProjectNotificationsMutation, EnableProjectNotificationsMutationVariables>;

          

          export type EnableProjectNotificationsMutationResult = ReturnType<typeof useEnableProjectNotificationsMutation>[1];

          
